export const ALL_GROUPS = {
  ALL: 'all',
  SELECTION: 'selection',
} as const;

export const QUERY_KEYS = {
  categories: 'categories',
} as const;
